module.exports = __webpack_public_path__ + "img/edge_patrimoine_memoire.42717d94.svg";